import { Tag } from "@fanduel/formation-react-components";
import NumberFireProjection from "@/components/scoreboard/NumberFireProjection";
import { NflGameState } from "../findGameState";
import styles from "./gameLines.module.scss";
interface GameLinesProps {
  homeTeamWinProbability?: number | null;
  spreadString: string;
  totalString: string;
  isMobile: boolean;
  gameState?: NflGameState;
}

const GameLines = ({
  homeTeamWinProbability,
  spreadString,
  totalString,
  isMobile,
  gameState,
}: GameLinesProps) => {
  let absoluteWP = 0;
  if (homeTeamWinProbability) {
    absoluteWP = Number(homeTeamWinProbability?.toFixed(1));
  }
  let homeProjectionsFavored = true;
  if (absoluteWP < 50 && absoluteWP > 0) {
    absoluteWP = 100 - absoluteWP;
    homeProjectionsFavored = false;
  }

  return (
    <div className={styles.gameLinesContainer}>
      {absoluteWP && !homeProjectionsFavored ? (
        <NumberFireProjection winProbability={absoluteWP} />
      ) : (
        <div className={styles.placeholder} />
      )}
      <div className={styles.gameLines}>
        {gameState === "LIVE" || gameState === "POST" ? (
          <Tag intent="neutral">Closing Lines</Tag>
        ) : null}
        <p>{spreadString}</p>
        {!isMobile ? <p>-</p> : null}
        <p>{totalString}</p>
      </div>
      {absoluteWP && homeProjectionsFavored ? (
        <NumberFireProjection winProbability={absoluteWP} isRightSide />
      ) : (
        <div className={styles.placeholder} />
      )}
    </div>
  );
};

export default GameLines;
